import { useQuery } from '@tanstack/react-query'
import { getCookie } from 'cookies-next'
import { LOYALTY_TOKEN_COOKIE } from '~/lib/auth-cookies'

const API_BASE_URL = process.env.NEXT_PUBLIC_LOYALTY_API_URL

// ponytail: replace `any` with real response type once loyalty /me spec is provided.
async function fetchMemberInfo(): Promise<any> {
  const accessToken = getCookie(LOYALTY_TOKEN_COOKIE)
  if (!accessToken || typeof accessToken !== 'string') return null

  const res = await fetch(`${API_BASE_URL}/me`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) {
    console.error('Failed to fetch member info', res.status)
    return null
  }

  return res.json()
}

export function useMemberInfo() {
  const accessToken = getCookie(LOYALTY_TOKEN_COOKIE)
  const enabled = typeof accessToken === 'string' && accessToken.length > 0

  return useQuery<any>({
    // Keyed by token so switching accounts (or logging back out) never serves
    // another account's cached profile while the new one is still fetching.
    queryKey: ['member-info', accessToken],
    queryFn: fetchMemberInfo,
    enabled,
    staleTime: 5 * 60 * 1000,
  })
}
